module.exports = __webpack_public_path__ + "84d95f3042eaf9eb26e3d9a132f82258.pdf";